import {validate} from "validate.js"
import {passwordStrength} from "check-password-strength"
import {isPossiblePhoneNumber} from "react-phone-number-input"

const PHONE_INPUT_KEY = "phone"
const MESSAGE = "Invalid phone number"

export const CHECK_PASSWORD_OPTIONS = {
    contains: {
        lowercase: "lowercase",
        uppercase: "uppercase",
        number: "number",
        symbol: "symbol"
    },
    values: {
        tooWeek: "Too weak",
        weak: "Weak",
        medium: "Medium",
        strong: "Strong"
    },
    length: "length",
    id: "id",
    default: {
        contains: [],
        length: -1,
        value: "",
        id: -1
    }
}

export function findErrors(
    json_data,
    rules
): {isValid: boolean; errors: {[key: string]: string} | null} {
    let r = validate(json_data, rules)
    const inputPhoneRules = Object.keys(rules).filter((key) => key.includes(PHONE_INPUT_KEY))
    console.log("inputPhoneRules:", {
        r,
        inputPhoneRules
    })
    const phoneErrors = validatePhoneInput(json_data, inputPhoneRules)
    if (!r && Object.keys(phoneErrors).length === 0) {
        return {isValid: true, errors: {}}
    }
    let r2 = {...r, ...phoneErrors}
    for (let key in r2) {
        r2[key] = r2[key][0]
    }
    console.log(r2)
    return {isValid: false, errors: r2}
}

export function validatePhoneInput(json_data: any, phoneInputs: any) {
    let phoneRules = {}
    for (const input of phoneInputs) {
        const phoneValue = !json_data[input] ? "" : json_data[input]
        if (!isPossiblePhoneNumber(phoneValue)) {
            phoneRules[input] = [MESSAGE]
        }
    }
    return phoneRules
}

export function findPasswordErrors(json_data): {isValid: boolean; options: any | null} {
    const {password} = json_data
    const passwordOptions = passwordStrength(password)
    const {value} = passwordOptions
    // console.log("@@@ passwordOptions:", toJS(passwordOptions))
    if (
        value === CHECK_PASSWORD_OPTIONS.values.strong ||
        value === CHECK_PASSWORD_OPTIONS.values.medium
    ) {
        return {isValid: true, options: passwordOptions}
    }
    return {isValid: false, options: passwordOptions}
}
